export enum CandidateProfileValidationStep {
  Name = 1,
  Visa = 2,
  Contact = 3,
  PersonalInfo = 4,
  JapaneseLevel = 5
}
